import React from 'react'
import Box from '@mui/joy/Box'
import Checkbox, { type CheckboxProps } from '@mui/joy/Checkbox'
import Typography from '@mui/joy/Typography'
import { useTranslation } from 'react-i18next'

export default function FullGarageToggle({
    value,
    handleChecked,
}:{
    value: boolean,
    handleChecked: CheckboxProps['onChange'],
}) {
  
    const { t } = useTranslation()

    return (
        <Box>
            <Typography level='title-md'>{t('filters.showAvailable')}</Typography>
            <Checkbox
                label={t('filters.yesShow')}
                variant="outlined"
                sx={{marginTop: 1.5}}
                checked={value}
                name="showAvailable"
                onChange={handleChecked}
            />
        </Box>
    )
}